module.exports = __webpack_public_path__ + "e5db5de50734c82537fb0e7dbb498337.svg";